import buttonsRetina from 'marketing-website/media/images/pages/features/prototyping/buttons@2x.png';
import chartRetina from 'marketing-website/media/images/pages/features/prototyping/chart@2x.png';
import iPhoneRetina from 'marketing-website/media/images/pages/features/prototyping/iPhone@2x.png';
import screenRecordingRetina from 'marketing-website/media/images/pages/features/prototyping/screenRecording@2x.png';
import searchRetina from 'marketing-website/media/images/pages/features/prototyping/search@2x.png';
import mapRetina from 'marketing-website/media/images/pages/features/prototyping/map@2x.png';
import linkRetina from 'marketing-website/media/images/pages/features/prototyping/link@2x.png';
import prototypeRetina from 'marketing-website/media/images/pages/features/prototyping/prototype@2x.jpg';
import mapBundleRetina from 'marketing-website/media/images/pages/features/prototyping/mapBundle@2x.png';
import prototypeFallbackRetina from 'marketing-website/media/images/pages/features/prototyping/prototypeFallback@2x.jpg';
import userTestingFallbackRetina from 'marketing-website/media/images/pages/features/prototyping/userTestingFallback@2x.png';

const assets = {
  buttons: {
    alt: 'Create realistic app and web prototypes in mins',
    src: buttonsRetina,
  },
  chart: {
    alt: 'Create realistic app and web prototypes in mins',
    src: chartRetina,
  },
  iPhone: {
    alt: 'Create realistic app and web prototypes in mins',
    src: iPhoneRetina,
  },
  avatar: {
    alt: 'Record emotions while testing apps',
    src: screenRecordingRetina,
    maxWidth: '167px',
  },
  search: {
    alt: 'Create realistic app and web prototypes in mins',
    src: searchRetina,
  },
  map: {
    alt: 'Create realistic app and web prototypes in mins',
    src: mapRetina,
  },
  link: {
    alt: 'Create realistic app and web prototypes in mins',
    src: linkRetina,
  },
  prototype: {
    alt: 'Present and share with developers, stakeholders, clients and users',
    src: prototypeRetina,
  },
  mapBundle: {
    alt: 'Validate ideas with User Testing',
    src: mapBundleRetina,
    maxWidth: 445,
  },
  prototypeFallback: {
    alt: '',
    maxWidth: 650,
    src: prototypeFallbackRetina,
  },
  userTestingFallback: {
    alt: 'Record user testing sessions',
    maxWidth: 605,
    src: userTestingFallbackRetina,
  },
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/pages/features/prototyping/assets.js